export default __webpack_public_path__ + "static/media/icon_insights.04e560aa.svg";